module.exports = ".alert-wrapper {\n  padding: 5px 90px 0 90px; }\n  .alert-wrapper .alert {\n    border-radius: 10px;\n    min-height: 30px;\n    margin-bottom: 5px; }\n  .alert-wrapper .alert .mat-icon {\n      color: inherit; }\n  .alert-wrapper .alert span {\n      white-space: pre-wrap; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pillar/alerts/components/alerts.component.scss
// module id = ./src/app/pillar/alerts/components/alerts.component.scss
// module chunks = main